var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2153_110033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.876 3.28799C44.6278 3.28905 45.3486 3.5882 45.8802 4.11982C46.4118 4.65145 46.711 5.37219 46.712 6.12402V45.876C46.711 46.6278 46.4118 47.3486 45.8802 47.8802C45.3486 48.4118 44.6278 48.711 43.876 48.712H4.12402C3.37219 48.711 2.65145 48.4118 2.11982 47.8802C1.5882 47.3486 1.28905 46.6278 1.28799 45.876V6.12402C1.28905 5.37219 1.5882 4.65145 2.11982 4.11982C2.65145 3.5882 3.37219 3.28905 4.12402 3.28799H43.876ZM43.876 2H4.12402C3.0306 2.00106 1.98225 2.43591 1.20908 3.20908C0.435911 3.98225 0.00105901 5.0306 0 6.12402V45.876C0.00105901 46.9694 0.435911 48.0177 1.20908 48.7909C1.98225 49.5641 3.0306 49.9989 4.12402 50H43.876C44.9691 49.9979 46.0169 49.5627 46.7898 48.7898C47.5627 48.0169 47.9979 46.9691 48 45.876V6.12402C47.9989 5.0306 47.5641 3.98225 46.7909 3.20908C46.0177 2.43591 44.9694 2.00106 43.876 2Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9068 2H34V50H44.9068C45.7268 49.9989 46.5129 49.6828 47.0927 49.121C47.6726 48.5592 47.9988 47.7976 48 47.0031V4.99687C47.9988 4.2024 47.6726 3.44078 47.0927 2.87901C46.5129 2.31724 45.7268 2.00112 44.9068 2Z",
    fill: "#00874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09321 2C2.2732 2.00112 1.4871 2.31724 0.907266 2.87901C0.327435 3.44078 0.00115412 4.2024 0 4.99687V47.0031C0.00115412 47.7976 0.327435 48.5592 0.907266 49.121C1.4871 49.6828 2.2732 49.9989 3.09321 50H14V2H3.09321Z",
    fill: "#00874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 2H14V50H34V2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2153_110033"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/Currency.bc1ddacd07862c04656ad13bce6cf21a.svg";
export { ForwardRef as ReactComponent };